export default __webpack_public_path__ + "static/media/33.723ef280.jpg";